import {Box, Button, Menu, MenuItem} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {isProduction} from '@/utils/environment';

import {AppButton, AppButtonVariant} from '../AppButton';

import {useActions} from './useActions';

const CONTAINER_STYLE = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'row',
  top: 4,
  right: 10,
  zIndex: 9999,
} as const;

const BUTTON_STYLE = {
  color: '#00000028',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '0.1px',
} as const;

/**
 * Non-production-only menu exposing dev/QA shortcuts (skip phone validation,
 * toggle country code visibility, jump between auth flows, clear session, etc).
 */
export function DevOptionsMenu() {
  const {t} = useTranslation();
  const {
    token,
    anchorEl,
    open,
    devButtonCountryCodeLabel,
    devButtonSkipPhoneValidationLabel,
    handleDevToolsClick,
    handleDevToolsClose,
    handleCopyToken,
    handleClearSession,
    handleGoToSignIn,
    handleIsCountryCodeVisible,
    handleIsSkipPhoneValidationEnabled,
    handleNavigateToTeenSignIn,
    handleNavigateToMoAIAssistant,
  } = useActions();

  if (isProduction) return null;

  return (
    <Box sx={CONTAINER_STYLE}>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleDevToolsClick}
        sx={BUTTON_STYLE}>
        {t('dev_buttons.dev_tools')}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleDevToolsClose}>
        {token && (
          <MenuItem>
            <AppButton
              removeStyles
              onClick={handleCopyToken}
              label={t('dev_buttons.copy_token')}
              variant={AppButtonVariant.devTool}
            />
          </MenuItem>
        )}
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleIsCountryCodeVisible}
            label={devButtonCountryCodeLabel}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleIsSkipPhoneValidationEnabled}
            label={devButtonSkipPhoneValidationLabel}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleGoToSignIn}
            label={t('dev_buttons.go_sign_in')}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleNavigateToTeenSignIn}
            label={t('dev_buttons.go_to_teen_sign_up')}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleNavigateToMoAIAssistant}
            label={t('dev_buttons.mo_ai')}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
        <MenuItem>
          <AppButton
            removeStyles
            onClick={handleClearSession}
            label={t('dev_buttons.clear_session')}
            variant={AppButtonVariant.devTool}
          />
        </MenuItem>
      </Menu>
    </Box>
  );
}
